import { Pagination, Table } from 'antd';
import React, { Fragment } from 'react';
import './style.scss';

const PAGE_SIZE_OPTION = ['5', '10', '20', '30', '50'];
export default (props) => {

	const {
		datasource,
		columns,
		page,
		bordered,
		className = '',
		expandedRowRender,
		setPage,
		rowKey = 'id',
		scrollToID,
		onSearch,
		pagination = true
	} = props;

	const { perpage, currentPage, total } = page;

	const onChange = (currentPage, perpage, isChangeSize = false) => {
		setPage({
			perpage: perpage,
			currentPage: isChangeSize ? 1 : currentPage
		});
		if (scrollToID) {
			window.location.href = '#' + scrollToID;
		} else {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
		onSearch({ currentPage, perpage });
	};

	return <Fragment>
		<Table className={className}
					 bordered={bordered}
					 dataSource={datasource}
					 columns={columns}
					 rowKey={rowKey}
					 expandedRowRender={expandedRowRender ? expandedRowRender : null}
					 pagination={false}
					 locale={{
						 emptyText: 'Không có dữ liệu'
					 }}
					 {...props}
		/>
		{pagination && <div id={'common_table'}>
			<Pagination defaultCurrent={1}
									locale={{ items_per_page: 'kết quả ' }}
									current={currentPage}
									total={total}
									pageSize={perpage}
									showSizeChanger
									onChange={(currentPage, perpage) => onChange(currentPage, perpage)}
									pageSizeOptions={PAGE_SIZE_OPTION}
									onShowSizeChange={(currentPage, perpage) => onChange(currentPage, perpage, true)}
									showTotal={(total, range) => `${range[0]}-${range[1]} trong ${total} kết quả`}
			/>
		</div>}
	</Fragment>;
}
